// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '휴온스',
  targetSheetName: '휴온스리스트_26.5월 기준_송부용',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '품목명',
    price: '약가',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '보험코드',
    '품목명',
    '성분',
    '23년9월 이전약가',
    '약가',
    '정책변경 내용 (vat포함)',
    '적용시점',
    '구간/요율 (vat포함)',
    '생동유무',
    '생동약가현황',
    '자사/위탁 현황',
    '대조약',
    '대조약 판매사',
    '비고',
  ],
});
